/* ========== ~~~~~~~~~~ QUEUE STATUS : ACTIONS ~~~~~~~~~~ ========== */
// ACTION
// utilized by reducers as a call to action to perform some kind of update to application state
// utilized in "_container" components and reducers



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export const SET_CURRENT_CONTENT = 'SET_CURRENT_CONTENT';
export const COMPLETE_QUEUE = "COMPLETE_QUEUE";
export const RESET_QUEUE = "RESET_QUEUE";
export const RESET_MULTIPLE_QUEUES = "RESET_MULTIPLE_QUEUES";

export const completeQueue = () => ({
    type: COMPLETE_QUEUE
});
export const resetQueue = () => ({
    type: RESET_QUEUE
});
export const resetMultipleQueues = () => ({
    type: RESET_MULTIPLE_QUEUES
});
export const setCurrentContent = contentId => ({
	type: SET_CURRENT_CONTENT,
    contentId
});
